import actions from './actions';

const { 
    ASM_SALES_DASHBOARD_BEGIN, ASM_SALES_DASHBOARD_SUCCESS, ASM_SALES_DASHBOARD_ERR,
    RANKING_DATA_DATA_BEGIN, RANKING_DATA_DATA_SUCCESS, RANKING_DATA_DATA_ERR,
} = actions;

const initialStateArray = { data: [], loading: false, error: null, };

export const asmSalesDashboardReducer = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ASM_SALES_DASHBOARD_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ASM_SALES_DASHBOARD_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ASM_SALES_DASHBOARD_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

// QR Payment Information Data Reducers
export const getStoreRankingDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case RANKING_DATA_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case RANKING_DATA_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case RANKING_DATA_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};
